/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Google_HintInputs */

const cs_auth_google_hint = /** @type {(inputs: Auth_Google_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funguje až po jednorázovém propojení Google v nastavení profilu (přihlášení e-mailem).`)
};

const en_auth_google_hint = /** @type {(inputs: Auth_Google_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Works only after you connect Google once in profile settings (see steps below if needed).`)
};

/**
* | output |
* | --- |
* | "Works only after you connect Google once in profile settings (see steps below if needed)." |
*
* @param {Auth_Google_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_google_hint = /** @type {((inputs?: Auth_Google_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Google_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_google_hint(inputs)
	return cs_auth_google_hint(inputs)
});